export const OUT_OF_DELIVERY_ZONE_ERROR = 'supera límite de distancia origen-entrega';

type ShippingErrorPattern = {
  pattern: string;
  lowerPattern: string;
  outOfZone?: boolean;
  rapiboy?: boolean;
  translationKey?: string;
};

const definePatterns = (
  entries: Omit<ShippingErrorPattern, 'lowerPattern'>[],
): ShippingErrorPattern[] =>
  entries.map(entry => ({ ...entry, lowerPattern: entry.pattern.toLowerCase() }));

const SHIPPING_ERROR_PATTERNS = definePatterns([
  {
    pattern: OUT_OF_DELIVERY_ZONE_ERROR,
    outOfZone: true,
    rapiboy: true,
    translationKey: 'shippingCostResponse.outOfDeliveryZoneAlert',
  },
  {
    pattern: 'No hay repartidores disponibles',
    rapiboy: true,
    translationKey: 'shippingCostResponse.shippingNoRidersAvailable',
  },
  {
    pattern: 'Error al calcular el envío con Rapiboy',
    rapiboy: true,
    translationKey: 'shippingCostResponse.coverageUnknownError',
  },
  {
    pattern: 'No se obtuvo una respuesta válida de Rapiboy',
    rapiboy: true,
    translationKey: 'shippingCostResponse.coverageUnknownError',
  },
  {
    pattern: 'No se pudo obtener el token de Rapiboy',
    rapiboy: true,
    translationKey: 'shippingCostResponse.coverageUnknownError',
  },
]);

const findMatchingPattern = (error: string): ShippingErrorPattern | undefined => {
  const lower = error.toLowerCase();
  return SHIPPING_ERROR_PATTERNS.find(({ lowerPattern }) => lower.includes(lowerPattern));
};

export const isOutOfZoneError = (error: string): boolean =>
  !!findMatchingPattern(error)?.outOfZone;

export const isRapiboyError = (error: string): boolean =>
  !!findMatchingPattern(error)?.rapiboy;

export function getShippingErrorTranslationKey(error: string | undefined | null): string | null {
  if (!error) return null;
  return findMatchingPattern(error)?.translationKey ?? null;
}
